import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-425e2fea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-input-icon-left search-bar"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "p-column-title" }
const _hoisted_4 = { class: "rank" }
const _hoisted_5 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_6 = { class: "badge-staking staked" }
const _hoisted_7 = { class: "badge-staking unstaked" }
const _hoisted_8 = { class: "p-column-title" }
const _hoisted_9 = { class: "p-column-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-column-title" }, "Comission", -1 /* HOISTED */))
const _hoisted_11 = { class: "p-column-title" }
const _hoisted_12 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_13 = {
  key: 0,
  class: "commision"
}
const _hoisted_14 = {
  key: 1,
  class: "commision"
}
const _hoisted_15 = {
  key: 2,
  class: "commision"
}
const _hoisted_16 = {
  key: 3,
  class: "commision"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "p-column-title" }
const _hoisted_19 = { class: "p-column-title" }
const _hoisted_20 = { class: "p-column-title" }
const _hoisted_21 = { class: "p-column-title" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "flex-container-details" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "item" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { style: {"max-width":"500px"} }
const _hoisted_29 = { style: {"font-weight":"bolder","margin-top":"20px","margin-bottom":"-20px"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-column-title" }, "Amount", -1 /* HOISTED */))
const _hoisted_31 = { class: "p-column-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createCommentVNode("    <StakingPopup v-if=\"!isUndelegationsTable() && popupOpened\" :validator=\"currentValidator\" @success=\"transactionSuccess\" @close=\"checkBTN\" :redelegation-direction=\"getRedelegationDirection()\"/>"),
    (!$setup.isUndelegationsTable() && $setup.popupOpened)
      ? (_openBlock(), _createBlock($setup["StakingPopupModal"], {
          key: 0,
          visible: $setup.popupOpened,
          validator: $setup.currentValidator,
          onSuccess: $setup.transactionSuccess,
          onClose: $setup.checkBTN,
          "redelegation-direction": $setup.getRedelegationDirection()
        }, null, 8 /* PROPS */, ["visible", "validator", "redelegation-direction"]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["DataTableWrapper"], {
      "data-key": 'operator_address',
      useExternalGlobalFilter: false,
      "eager-loading-config": $setup.createEagerLoadingConfig(),
      "expanded-rows": $setup.expandedRow,
      onRowClick: $setup.onRowClick,
      paginator: false
    }, _createSlots({
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("STAKING_VIEW.NO_VALIDATORS")), 1 /* TEXT */)
      ]),
      header: _withCtx(() => [
        _createElementVNode("div", null, [
          ($setup.isValidatorsTable())
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _hoisted_2,
                _createVNode(_component_InputText, {
                  style: {"width":"100%"},
                  type: "text",
                  modelValue: $setup.filters['global'].value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters['global'].value) = $event)),
                  placeholder: "Search"
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createElementVNode("i", {
                  class: "pi pi-times-circle",
                  style: {"transform":"translateX(-30px)"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.filters['global'].value = ''))
                })
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      columns: _withCtx(() => [
        ($setup.isValidatorsTable())
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              field: "rank",
              header: _ctx.$t(`STAKING_VIEW.TABLE.RANK`),
              sortable: true
            }, {
              body: _withCtx(({data}) => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.RANK`)), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass(data.delegatedAmount > 0n ? '' : 'opacity-0'),
                      style: {"display":"flex","margin":"1px 0"}
                    }, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(`STAKING_VIEW.INDICATOR.STAKE`)), 1 /* TEXT */)
                    ], 2 /* CLASS */),
                    _createElementVNode("div", {
                      class: _normalizeClass(data.undelegatingAmount > 0n ? '' : 'opacity-0'),
                      style: {"display":"flex","margin":"1px 0"}
                    }, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(`STAKING_VIEW.INDICATOR.UNSTAKING`)), 1 /* TEXT */)
                    ], 2 /* CLASS */)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(data.rank), 1 /* TEXT */)
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["header"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_Column, {
          field: "description.moniker",
          header: _ctx.$t(`STAKING_VIEW.TABLE.NAME`),
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.NAME`)), 1 /* TEXT */),
            _createVNode($setup["ValidatorLogo"], { validator: data }, null, 8 /* PROPS */, ["validator"]),
            _createElementVNode("span", null, _toDisplayString(data.description.moniker), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["header"]),
        ($setup.isValidatorsTable() || $setup.isDelegationsTable())
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 1,
              field: "status",
              header: _ctx.$t(`STAKING_VIEW.TABLE.STATUS`),
              sortable: true
            }, {
              body: _withCtx(({data}) => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.STATUS`)), 1 /* TEXT */),
                _createVNode($setup["ValidatorStatusBadge"], { validator: data }, null, 8 /* PROPS */, ["validator"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["header"]))
          : _createCommentVNode("v-if", true),
        ($setup.isValidatorsTable())
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 2,
              field: "commission.rate",
              header: "Commission",
              sortable: true,
              sortField: "commission.rate"
            }, {
              body: _withCtx(({data}) => [
                _hoisted_10,
                _createVNode($setup["PercentsView"], {
                  amount: data.commission.rate,
                  precision: 2
                }, null, 8 /* PROPS */, ["amount"])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        ($setup.isValidatorsTable())
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 3,
              field: "votingPower",
              header: _ctx.$t(`STAKING_VIEW.TABLE.VOTING_POWER`),
              sortable: true,
              sortField: "tokens"
            }, {
              body: _withCtx(({data}) => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.VOTING_POWER`)), 1 /* TEXT */),
                (data.votingPower)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (data.votingPower < 0.05)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", {
                              class: "level-1",
                              style: _normalizeStyle('flex-basis:' + (data.votingPower * 100).toFixed(2) + '%')
                            }, null, 4 /* STYLE */),
                            _createVNode($setup["PercentsView"], {
                              class: "level-border",
                              amount: data.votingPower,
                              precision: 2
                            }, null, 8 /* PROPS */, ["amount"])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (data.votingPower >= 0.05 && data.votingPower < .10)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", {
                              class: "level-2",
                              style: _normalizeStyle('flex-basis:' + (data.votingPower * 100).toFixed(2) + '%')
                            }, null, 4 /* STYLE */),
                            _createVNode($setup["PercentsView"], {
                              class: "level-border",
                              amount: data.votingPower,
                              precision: 2
                            }, null, 8 /* PROPS */, ["amount"])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (data.votingPower >= .10 && data.votingPower < .25)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", {
                              class: "level-3",
                              style: _normalizeStyle('flex-basis:' + (data.votingPower * 100).toFixed(2) + '%')
                            }, null, 4 /* STYLE */),
                            _createVNode($setup["PercentsView"], {
                              class: "level-border",
                              amount: data.votingPower,
                              precision: 2
                            }, null, 8 /* PROPS */, ["amount"])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (data.votingPower >= .25)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", {
                              class: "level-4",
                              style: _normalizeStyle('flex-basis:' + (data.votingPower * 100).toFixed(2) + '%')
                            }, null, 4 /* STYLE */),
                            _createVNode($setup["PercentsView"], {
                              class: "level-border",
                              amount: data.votingPower,
                              precision: 2
                            }, null, 8 /* PROPS */, ["amount"])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17, "updating"))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["header"]))
          : _createCommentVNode("v-if", true),
        ($setup.isDelegationsTable())
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 4,
              header: _ctx.$t(`STAKING_VIEW.TABLE.STAKE`),
              sortable: true,
              sortField: "delegatedAmount"
            }, {
              body: _withCtx(({data}) => [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.STAKE`)), 1 /* TEXT */),
                _createVNode($setup["CoinAmount"], {
                  amount: new $setup.BigIntWrapper(data.delegatedAmount),
                  "show-denom": true
                }, null, 8 /* PROPS */, ["amount"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["header"]))
          : _createCommentVNode("v-if", true),
        ($setup.isDelegationsTable())
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 5,
              header: _ctx.$t(`STAKING_VIEW.TABLE.REWARDS`),
              sortable: true,
              sortField: "rewardsAmountSort"
            }, {
              body: _withCtx(({data}) => [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.REWARDS`)), 1 /* TEXT */),
                _createVNode($setup["CoinAmount"], {
                  amount: data.rewardsAmount,
                  "show-denom": true
                }, null, 8 /* PROPS */, ["amount"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["header"]))
          : _createCommentVNode("v-if", true),
        ($setup.isUndelegationsTable())
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 6,
              header: _ctx.$t(`STAKING_VIEW.TABLE.UNSTAKING`),
              sortable: true,
              sortField: "entry.amount"
            }, {
              body: _withCtx(({data}) => [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.UNSTAKING`)), 1 /* TEXT */),
                _createVNode($setup["CoinAmount"], {
                  amount: data.entry.amount,
                  "show-denom": true
                }, null, 8 /* PROPS */, ["amount"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["header"]))
          : _createCommentVNode("v-if", true),
        ($setup.isUndelegationsTable())
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 7,
              header: _ctx.$t(`STAKING_VIEW.TABLE.UNSTAKING_COMPLETION`),
              sortable: true,
              sortField: "entry.completionTime"
            }, {
              body: _withCtx(({data}) => [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.UNSTAKING_COMPLETION`)), 1 /* TEXT */),
                _createElementVNode("span", null, [
                  _createVNode($setup["DateCommon"], {
                    date: data.entry.getCompletionTimeDate()
                  }, null, 8 /* PROPS */, ["date"])
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["header"]))
          : _createCommentVNode("v-if", true),
        (!$setup.isUndelegationsTable())
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 8,
              field: "operator_address"
            }, {
              body: _withCtx(({data}) => [
                _createVNode(_component_Button, {
                  class: "outlined",
                  onClick: ($event: any) => ($setup.checkBTN(data))
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["StakeManagementIcon"], { icon: "manage" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE_BUTTONS.MANAGE_BTN`)), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        ($setup.isLoggedIn && $setup.isValidatorsTable())
          ? (_openBlock(), _createBlock(_component_Column, { key: 9 }, {
              body: _withCtx(({data}) => [
                ($setup.isValidatorRowExpandable(data))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => ($setup.onRowExpand(data))
                    }, [
                      (data.operatorAddress !== $setup.expandedRow[0]?.operatorAddress)
                        ? (_openBlock(), _createBlock(_component_Icon, {
                            key: 0,
                            onClick: ($event: any) => ($setup.onRowExpand(data)),
                            name: "ChevronRight"
                          }, null, 8 /* PROPS */, ["onClick"]))
                        : _createCommentVNode("v-if", true),
                      (data.operatorAddress === $setup.expandedRow[0]?.operatorAddress)
                        ? (_openBlock(), _createBlock(_component_Icon, {
                            key: 1,
                            onClick: ($event: any) => ($setup.onRowExpand(data)),
                            name: "ChevronDown"
                          }, null, 8 /* PROPS */, ["onClick"]))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_22))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 2 /* DYNAMIC */
    }, [
      ($setup.isValidatorsTable())
        ? {
            name: "expanded-columns",
            fn: _withCtx(({expandedData}) => [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.STAKE`)), 1 /* TEXT */),
                  _createVNode($setup["CoinAmount"], {
                    amount: new $setup.BigIntWrapper(expandedData.data.delegatedAmount),
                    "show-denom": true
                  }, null, 8 /* PROPS */, ["amount"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.UNSTAKING`)), 1 /* TEXT */),
                  _createVNode($setup["CoinAmount"], {
                    amount: new $setup.BigIntWrapper(expandedData.data.undelegatingAmount),
                    "show-denom": true
                  }, null, 8 /* PROPS */, ["amount"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.REWARDS`)), 1 /* TEXT */),
                  _createVNode($setup["CoinAmount"], {
                    amount: expandedData.data.rewardsAmount,
                    "show-denom": true
                  }, null, 8 /* PROPS */, ["amount"])
                ])
              ]),
              (expandedData.data.undelegatingEntries && expandedData.data.undelegatingEntries.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode($setup["DataTableWrapper"], {
                        useExternalGlobalFilter: false,
                        "eager-loading-config": $setup.createValidatorUndelegationEntriesEagerLoadingConfig(expandedData.data.undelegatingEntries),
                        paginator: false
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("h5", _hoisted_29, _toDisplayString(_ctx.$t("STAKING_VIEW.USER_UNDELEGATIONS")), 1 /* TEXT */)
                        ]),
                        columns: _withCtx(() => [
                          _createVNode(_component_Column, {
                            field: "amount",
                            header: "Amount",
                            style: {"width":"200px"},
                            sortable: false
                          }, {
                            body: _withCtx(({data}) => [
                              _hoisted_30,
                              _createVNode($setup["CoinAmount"], {
                                amount: data.amount,
                                "show-denom": true
                              }, null, 8 /* PROPS */, ["amount"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_Column, {
                            field: "completionTime",
                            header: _ctx.$t(`STAKING_VIEW.TABLE.UNSTAKING_COMPLETION`),
                            sortable: false
                          }, {
                            body: _withCtx(({data}) => [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t(`STAKING_VIEW.TABLE.UNSTAKING_COMPLETION`)), 1 /* TEXT */),
                              _createVNode($setup["DateCommon"], {
                                date: data.completionTime
                              }, null, 8 /* PROPS */, ["date"])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["header"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["eager-loading-config"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["eager-loading-config", "expanded-rows"])
  ]))
}